import { render, staticRenderFns } from "./SpecialistTravel.vue?vue&type=template&id=706dc600"
import script from "./SpecialistTravel.vue?vue&type=script&lang=js"
export * from "./SpecialistTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports